import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

/**
 * Fetches the org's ENABLED specialist personas for the Query-page council
 * selector. The endpoint deliberately omits backing model ids — physicians
 * choose specialists, not raw models.
 *
 * Returns { personas, defaultCouncil, loading } where `personas` is a list of
 * { id, display_name, specialty, color, avatar } and `defaultCouncil` is the
 * org's default persona-id selection.
 */
export const useCouncilPersonas = () => {
  const [personas, setPersonas] = useState([]);
  const [defaultCouncil, setDefaultCouncil] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/settings/personas`)
      .then((res) => {
        if (!mounted) return;
        setPersonas(res.data?.data?.personas || []);
        setDefaultCouncil(res.data?.data?.default_council || []);
      })
      .catch(() => {
        /* non-fatal: selector hides itself, query falls back to org default */
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { personas, defaultCouncil, loading };
};

export default useCouncilPersonas;
